<template>
    <Modal class="edit-submis-modal" :is_show="is_show_edit_modal" @click-bg="close"
        :class="{ 'is-loading': $store.state.is_loading }">
        <header class="edit-header">
            <h2>Submission message</h2>
        </header>

        <Scrollbar class="edit-scroll-list" :show_bar="true">
            <Form :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="user-form-wrap"
                :class="{ 'is-error': is_error }" ref="form">
                <div class="name-box">
                    <label class="label">
                        Title <span class="req"> *</span>
                    </label>
                    <Field type="text" k="title" :placeholder="title_value.client_view.plac" :had_value="values.title"
                        :error_msg="errors.title" :is_success="success.title" @update="update"
                        :ref="(el) => { els.push(el) }" />
                </div>


                <div class="name-box">
                    <label class="label">Detail <span class="req"> *</span></label>
                    <Field type="textarea" k="detail" :placeholder="detail_value.client_view.plac" :had_value="values.detail"
                        :error_msg="errors.detail" :is_success="success.detail" @update="update"
                        :ref="(el) => { els.push(el) }" />
                </div>

                <div class="name-box name-box-cant-edit">
                    <label class="label2">Fixed system message</label>
                    <p>{{ fixed_value.client_view.val ? fixed_value.client_view.val : fixed_value.client_view.plac }}</p>
                </div>

                <br>

                <div class="btn-wrap-box">
                    <div class="open-pre" @click="$emit('openPre', handle_data )">Preview</div>
                    <div class="btn-wrap">
                        <Button type="button" :style="'border'" size="32" :border_r="6" @click.native="close()">Cancel</Button>
                        <Button type="submit" color="dark-blue" size="32" :border_r="6">Create</Button>
                    </div>
                </div>
            </Form>
        </Scrollbar>
    </Modal>

</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';

import * as yup from 'yup';
import { Tippy } from 'vue-tippy';

export default {
    name: 'edit-creator',
    emits: ['save'],

    components: {
        Field,
        Button,
        Form,
        Modal,
        Tippy,
        Scrollbar,
    },

    props:{
        need_des: {
            type: Boolean,
            default: false
        },
        is_edit: {
            type: Boolean,
            default: false
        },
        ambassador_application_id: {
            type: Number,
            default: 0
        },
        application_status:{
            type: String,
            default: 'draft'
        }
    },

    data() {
        return {
            is_show_edit_modal: false,
            is_error: false,
            error_msg: '',
            els: [],

            values: {
                title:'',
                detail:'',
            },

            schema: yup.object().shape({
                title: yup.string().required('The title can’t be left blank'),
                detail: yup.string().required('The detail can’t be left blank'),
            }),
            all_value:[],
            title_value:{},
            detail_value:{},
            fixed_value:{},
            errors: {},
            success: {},
            key_ref:0,

        }
    },

    computed: {
        handle_data(){
            let getV=this.all_value;
            getV.group_setting[0].client_view.val=this.values.title;
            getV.group_setting[1].client_view.val=this.values.detail;
            return getV;
        }
    },

    methods: {

        update(obj) {
            this.is_error = false;
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.values[key] = obj.val;
            });
            //errors
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.errors[key] = '';
            });
        },

        submit() {
            this.$emit('save',this.handle_data);
            this.close();
        },

        async open(val) {
            this.els = [];
            this.is_error = false;
            this.error_msg = '';
            this.is_show_edit_modal = true;
            if(val){
                const useVal=(val)=>{
                    return val.val ? val.val: val.plac;
                }
                this.all_value=JSON.parse(JSON.stringify(val));
                this.title_value=val.group_setting[0];
                this.detail_value=val.group_setting[1];
                this.fixed_value=val.group_setting[2];
                this.values.title=useVal(val.group_setting[0].client_view);
                this.values.detail=useVal(val.group_setting[1].client_view);
            }else{
                this.values.title='';
                this.values.detail= '';
            } 
        },

        close() {
            this.is_show_edit_modal = false;
            this.is_error = false;
            this.error_msg = '';
        },

    },

}
</script>
<style lang="scss">
.edit-submis-modal {
    .ui-modal--container {
        background-color: var(--bg-02);
        width: 620px;
        padding: 16px;
    }

    .edit-header {
        display: flex;
        align-items: center;

        h2 {
            font: var(--font-demi-20);
            color: var(--black-90);
            flex: 1;
            line-height: 1;
        }

        i {
            height: 12px;
            width: 12px;
            position: relative;
            display: block;
            cursor: pointer;

            svg {
                height: 12px;
                width: 12px;
                fill: var(--black-50);
            }
        }
    }

    .user-form-wrap {
        margin-top: 16px;

        .name-box {
            position: relative;
        }

        .label {
            font: var(--font-fg-16);
            color: var(--black-90);
            display: flex;
            align-items: center;

            span{
                cursor: pointer;
            }

            .svg-icon{
                width: 12px;
                height: 12px;
                fill:var(--neutral);
            }

            .req {
                color: var(--alert);
            }
        }

        input {
            width: 100%;
            padding: 6px 8px;
            font-size: 14px;
            color: var(--black-90);
            outline: none;
            height: 36px;
            border: 1px solid var(--black-20);
            border-radius: 6px;

            &:focus {
                border: 1px solid var(--dark-blue);
            }
        }


        .input {
            position: relative;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            flex: 1;

            label {
                height: 36px;
                background: #CBD4E1;
                padding: 0 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: var(--black-90);
                border-radius: 6px 0px 0px 6px;
            }
            
            input {
                border-radius: 0 6px 6px 0;
                font-family: var(--font);
                flex:1;
                margin: 12px 0;

                &::placeholder {
                    color: var(--black-50);
                    font-weight: 500;
                }

                &:disabled{
                    cursor: not-allowed;
                }
            }
            .ui-input{
                flex:1;
            }
        }

        .name-box-cant-edit{
            .label2{
               font-size: 14px;
            }

            p{
                font-size: 14px;
                color:var(--black-50);
            }
        }

        .desc {
            font-size: 14px;
            color: var(--black-75);
        }

        .ui-input {
            margin: 12px 0;
            position: relative;
        }

        .err-msg-box{
            position: absolute;
            right: 0;
        }

        .btn-wrap-box{
            display: flex;
            justify-content: space-between;
            align-items: center;

            .open-pre{
                color:var(--blue);
                font-size:12px;
                cursor:pointer;
            }
        }

        .btn-wrap {
            display: flex;
            justify-content: flex-end;

            .ui-button {
                width: 110px;
                padding: unset;

                &:first-child{
                    margin-right: 16px;
                }
            }
        }

        &.is-error {

            .ui-input .ui-input--wrap select,
            .ui-input .ui-input--wrap input,
            .ui-input .ui-input--select select,
            .ui-input .ui-input--select input,
            .ui-input .ui-input--icon-wrap {
                border-color: var(--alert) !important;
            }

            .error-msg {
                margin: 4px 0 0;
                font-size: 12px;
                color: var(--alert);

                &::before {
                    content: '*';
                }
            }
        }

        .coll-chec {
            .ui-checkbox {
                margin-top: 8px;
            }
        }

        .name-box-err{
            .the-input input{
                border: 1px solid var(--alert);
            }
        }

        .err-client-msg-box{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color:var(--alert);
            position: absolute;
            bottom: -10px;
            right: 0;
            font-size: 12px;

            &.err-client-msg-box-2{
                bottom: -20px;
            }

            i{
                width: 14px;
                height: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;
            }

            svg{
                width: 10.5px;
                height: 10.5px;
                fill:var(--alert);
            }
        }
    }

    &.is-loading {
        .user-form-wrap {
            opacity: .5;
            pointer-events: none;
        }
    }


}
</style>
